<ng-container *ngIf="isButtonWithLoader else notBuyButton">
  <div [action]="item.action" [item]="item" special-block></div>

  <div *ngIf="showLoader | async" class="loader">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
</ng-container>

<ng-template #notBuyButton>
  <div [action]="item.action" [item]="item" special-block></div>
</ng-template>
 